/**
 *  数组中每项数据的描述 按照数据显示
 *  [0] moduleName E10模块标示
 *  [1] oldModuleName 旧模块标识
 *  [2] registry 仓库名称
 *  [3] mAddress H5列表地址
 *  [4] mDetailAddress H5详情地址
 *  [5] detailAddress PC端详情页面
 *  [6] AddDialogAddress PC端新建弹窗组件
 *  [7] dialogAddress 对应的事项卡片组件（居中弹框）
 *  [8] slidedDialogAddress 对应的事项卡片组件（侧边弹框）
 *  [9] associatedButton 对应浏览按钮的类型标示
 */
export const moduleRouterConfig: string[][] = [
  [
    "fna",
    "fna",
    "@weapp/fna",
    "/mobile/fna/apply",
    "/mobile/fna/fnampage/wfform/{id}",
    "/sp/fna/detail/{id}",
    "FnaViewDialog",
    "FnaViewDialog",
    "FnaViewSideDialog",
    ""
  ],
  [
    "fna",
    "fnaAdWf",
    "@weapp/fna",
    "/mobile/fna/apply",
    "/mobile/fna/home/flowpage/sideDialog/view/{id}",
    "/sp/fna/flowpage/centerDialog/view/{id}",
    "",
    "FnaViewDialogAd",
    "FnaViewSideDialogAd",
    "relateApprove,FexsBorrowRequestBrowser"
  ],
  [
    "fna",
    "fnaBudgetApproval",
    "@weapp/fna",
    "",
    "",
    "/sp/fna/approvalFill/{id}",
    "",
    "FnaApprovalFillDialog",
    "FnaApprovalFillDialog",
    ""
  ],
  [
    "meeting",
    "meetingVideo",
    "@weapp/meeting",
    "",
    "/mobile/meeting/myVideoMeeting/index/detail/{id}",
    "",
    "",
    "MeetingVideoViewDialog",
    "MeetingVideoViewDialog",
    "mt_video"
  ],
  ["my", "wait", "@weapp/my", "", "", "", "", "MyWaitDetailCenter", "MyWaitDetail", ""],
  [
    "odoc",
    "odoc",
    "@weapp/odoc",
    "/mobile/odoc",
    "/mobile/odoc/flowForm/view/{id}",
    "/sp/odoc/msgFlowForm/view/{id}",
    "OdocMsgNewFlowDialog",
    "OdocMsgFlowViewDialog",
    "OdocMsgFlowViewSideDialog",
    "odocRequest"
  ],
  [
    "meeting",
    "meeting",
    "@weapp/meeting",
    "",
    "/mobile/meeting/detail/{id}",
    "/sp/meeting/meetingSingle?meetingId={id}",
    "MeetingViewDialog",
    "MeetingViewDialog",
    "MeetingViewSideDialog",
    "mt"
  ],
  [
    "cowork",
    "cowork",
    "@weapp/cowork",
    "/mobile/cowork/discuss",
    "/mobile/cowork/discuss/view/{id}",
    "/sp/cowork/view/{id}",
    "",
    "CoworkViewEditDialog",
    "CoworkViewEditSideDialog",
    "coworkItemsBrowser"
  ],
  [
    "market",
    "marketArticle",
    "@weapp/market",
    "",
    "",
    "/sp/market/articleViewPage/{id}",
    "",
    "MarketArticleViewMiddleDialog",
    "MarketArticleViewMiddleDialog",
    "articleBrowser"
  ],
  [
    "market",
    "market",
    "@weapp/market",
    "",
    "",
    "/sp/market/articleViewPage/{id}",
    "",
    "MarketArticleViewMiddleDialog",
    "MarketArticleViewMiddleDialog",
    ""
  ],
  [
    "salary",
    "hrsa_mySalaryBill",
    "@weapp/salary",
    "",
    "/mobile/salary/mySalaryBill/view/{id}",
    "/sp/salary/mySalaryBill/view/{id}",
    "",
    "MySalaryBillViewDialog",
    "MySalaryBillViewDialog",
    ""
  ],
  [
    "formreport",
    "formreport_vote",
    "@weapp/formreport",
    "/mobile/formreport",
    "/mobile/formreport/dataDetail/{id}",
    "",
    "",
    "FormReportVoteDetailDialog",
    "FormReportVoteDetailDialog",
    ""
  ],
  ["attend", "subscribeattend", "@weapp/attend", "", "", "", "", "SubscriptDialog", "SubscriptSideDialog", ""],
  [
    "blog",
    "subscribeblog",
    "@weapp/blog",
    "/mobile/blog/subscribe/{id}",
    "",
    "",
    "",
    "BlogSubscriptionDialog",
    "BlogSubscriptionDialog",
    ""
  ],
  [
    "crm",
    "quote",
    "@weapp/crm",
    "/mobile/crm/quote",
    "/mobile/crm/quote/0/quoteInfo/{id}",
    "/sp/crm/quote/quoteViewPage/{id}",
    "CrmCreateQuoteDialogProvider",
    "CrmQuoteViewMiddleDialog",
    "CrmQuoteViewDialogProvider",
    "quote"
  ],
  [
    "crm",
    "capital",
    "@weapp/crm",
    "/mobile/crm/capital",
    "/mobile/crm/capital/0/capitalInfo/{id}",
    "/sp/crm/capital/capitalViewPage/{id}",
    "CrmCreateCapitalDialogProvider",
    "CrmCapitalViewMiddleDialog",
    "CrmCapitalViewDialogProvider",
    "capital"
  ],
  [
    "placard",
    "placard",
    "@weapp/placard",
    "/mobile/placard/list",
    "/mobile/placard/page/{id}",
    "",
    "",
    "PlaCardListMiddleDiagLog",
    "PlaCardListRightDiaLog",
    ""
  ],
  [
    "performance",
    "kpiSchemeSetting",
    "@weapp/performance",
    "/mobile/performance/scheme",
    "/mobile/performance/schemeDetail/{id}",
    "",
    "",
    "PerofrmanceSchemeViewDialog",
    "PerformanceSchemeViewSideDialog",
    ""
  ],
  [
    "performance",
    "performance",
    "@weapp/performance",
    "/mobile/performance/main/list",
    "/mobile/performance/flow/detail/{id}",
    "/sp/performance/flow/deal/detail/{id}",
    "",
    "PerformanceViewDialog",
    "PerformanceViewSideDialog",
    "performanceBrowser"
  ],
  [
    "performance",
    "kpiFlow",
    "@weapp/performance",
    "/mobile/performance/main/list",
    "/mobile/performance/flow/detail/{id}",
    "/sp/performance/flow/deal/detail/{id}",
    "",
    "PerformanceViewDialog",
    "PerformanceViewSideDialog",
    ""
  ],
  ["attend", "attendAppeal", "@weapp/attend", "", "", "", "", "AbnormalAppealDialog", "AbnormalAppealSideDialog", ""],
  [
    "hrm",
    "hrcontract",
    "@weapp/hrm",
    "/mobile/hrm/contractManager",
    "/mobile/hrm/contractManager/info/{id}",
    "/sp/hrm/contract/{id}",
    "",
    "HrmContractViewDialog",
    "HrmContractViewSideDialog",
    ""
  ],
  [
    "hrm",
    "hruserinfo",
    "@weapp/hrm",
    "",
    "/mobile/hrm/profile/{id}",
    "/sp/hrm/profileInfo/{id}",
    "",
    "HrmProfileViewDialog",
    "HrmProfileViewSideDialog",
    ""
  ],
  [
    "ebuilder/form",
    "ebuilderform",
    "@weapp/ebdfpage",
    "/mobile/ebdfpage/list/{viewId}",
    "/mobile/ebdfpage/card/0/{id}",
    "/sp/ebdfpage/card/0/{id}",
    "EbCardCreateDialog",
    "EbCardViewDialog",
    "EbCardViewSideDialog",
    "ebuilder,ebuilderMatter,ebuilderSingleMatter"
  ],
  [
    "doc",
    "coordinateDocument",
    "@weapp/doc",
    "",
    "/mobile/doc/docDetail/{id}",
    "",
    "DocCollaborationDialog",
    "DocCollaborationDialog",
    "DocCollaborationSideDialog",
    "coordinateDocument"
  ],
  [
    "formreport",
    "formreport_voteList",
    "@weapp/formreport",
    "/mobile/formreport",
    "/mobile/formreport/groupVoteList/{id}",
    "",
    "",
    "FormReportGroupVoteListDialog",
    "FormReportGroupVoteListDialog",
    ""
  ],
  [
    "salary",
    "hrsa_mySalaryBill",
    "@weapp/salary",
    "",
    "/mobile/salary/mySalaryBill/view/{id}",
    "/sp/salary/mySalaryBill/view/{id}",
    "",
    "MySalaryBillViewDialog",
    "MySalaryBillViewSideDialog",
    ""
  ],
  [
    "odoc",
    "odocExchangeReceive",
    "@weapp/odoc",
    "",
    "/mobile/odoc/exchange/receiveForm/{id}",
    "/sp/odoc/exchange/receiveForm/{id}",
    "",
    "OdocExchangeReceiveFormDialog",
    "OdocExchangeReceiveFormSideDialog",
    ""
  ],
  [
    "odoc",
    "odocExchangeSend",
    "@weapp/odoc",
    "",
    "/mobile/odoc/exchange/receiveList/{id}",
    "/sp/odoc/exchange/receiveList/{id}",
    "",
    "OdocExchangeReceiveViewDialog",
    "OdocExchangeReceiveViewSideDialog",
    ""
  ],
  [
    "crm",
    "risk",
    "@weapp/crm",
    "",
    "/mobile/crm/contract/0/contractRiskInfo/{id}",
    "/sp/crm/contract/contractRiskViewPage/{id}",
    "",
    "CrmRiskViewMiddleDialog",
    "CrmRiskViewMiddleDialog",
    ""
  ],
  [
    "crm",
    "receive",
    "@weapp/crm",
    "",
    "/mobile/crm/contract/0/ledger/receive/{id}",
    "/sp/crm/contract/contractLedgerViewPage/receive/{id}",
    "",
    "CrmContractPeriodReceiveMiddleDialog",
    "CrmContractPeriodReceiveMiddleDialog",
    ""
  ],
  [
    "crm",
    "pay",
    "@weapp/crm",
    "",
    "/mobile/crm/contract/0/ledger/pay/{id}",
    "/sp/crm/contract/contractLedgerViewPage/pay/{id}",
    "",
    "CrmContractPeriodPayMiddleDialog",
    "CrmContractPeriodPayMiddleDialog",
    ""
  ],
  [
    "crm",
    "invoice",
    "@weapp/crm",
    "",
    "/mobile/crm/contract/0/ledger/invoice/{id}",
    "/sp/crm/contract/contractLedgerViewPage/invoice/{id}",
    "",
    "CrmContractPeriodInoviceMiddleDialog",
    "CrmContractPeriodInoviceMiddleDialog",
    ""
  ],
  [
    "workflow",
    "ebuilderworkflow",
    "@weapp/workflow",
    "/mobile/workflow/index/list",
    "/mobile/workflow/flowpage/view/{id}",
    "/sp/workflow/flowpage/view/{id}",
    "WfCLNewFlowVisibleDialog",
    "WorkflowViewDialog",
    "WorkflowViewSideDialog",
    ""
  ],
  [
    "market",
    "marketResource_webpage",
    "@weapp/market",
    "/mobile/market/resource/webpage",
    "/mobile/market/resource/common/resourceInfo/{id}",
    "/sp/market/resourceCommon/{id}",
    "",
    "MarketResourceViewMiddleDialog",
    "MarketResourceViewMiddleDialog",
    ""
  ],
  [
    "market",
    "marketResource_image",
    "@weapp/market",
    "/mobile/market/resource/image",
    "/mobile/market/resource/common/resourceInfo/{id}",
    "/sp/market/resourceCommon/{id}",
    "",
    "MarketResourceViewMiddleDialog",
    "MarketResourceViewMiddleDialog",
    ""
  ],
  [
    "market",
    "marketResource_text",
    "@weapp/market",
    "/mobile/market/resource/text",
    "/mobile/market/resource/common/resourceInfo/{id}",
    "/sp/market/resourceCommon/{id}",
    "",
    "MarketResourceViewMiddleDialog",
    "MarketResourceViewMiddleDialog",
    ""
  ],
  [
    "market",
    "marketResource_moments",
    "@weapp/market",
    "/mobile/market/resource/moments",
    "/mobile/market/resource/common/resourceInfo/{id}",
    "/sp/market/resourceCommon/{id}",
    "",
    "MarketResourceViewMiddleDialog",
    "MarketResourceViewMiddleDialog",
    ""
  ],
  [
    "workflow",
    "workflow_exception",
    "@weapp/workflow",
    "",
    "/mobile/workflow/flowpage/mexceptionHandle{id}",
    "",
    "",
    "WorkflowExceptionHandleViewDialog",
    "WorkflowExceptionHandleViewSideDialog",
    ""
  ],
  ["edc", "edcapp", "@weapp/edc", "", "", "", "", "MultipleTaskDetailDialog", "MultipleTaskDetailDialog", ""],
  [
    "hrm",
    "HrmBirthdayReminder",
    "@weapp/hrm",
    "",
    "/mobile/hrm/birthdayReminder",
    "",
    "",
    "BirthdayReminderCard",
    "BirthdayReminderCard",
    ""
  ],
  [
    "hrm",
    "HrmBirthdayAdminReminder",
    "@weapp/hrm",
    "",
    "",
    "",
    "",
    "BirthdayAdminReminder",
    "BirthdayAdminReminder",
    ""
  ],
  [
    "hrm",
    "HrmAnniversaryReminder",
    "@weapp/hrm",
    "",
    "/mobile/hrm/anniversaryReminder",
    "",
    "",
    "AnniversaryReminderCard",
    "AnniversaryReminderCard",
    ""
  ],
  [
    "hrm",
    "HrmAnniversaryAdminReminder",
    "@weapp/hrm",
    "",
    "",
    "",
    "",
    "AnniversaryAdminReminder",
    "AnniversaryAdminReminder",
    ""
  ],
  [
    "meeting",
    "meetingRoom",
    "@weapp/meeting",
    "",
    "",
    "/sp/meeting/meetingRoomSingle?roomId={id}",
    "",
    "MeetingRoomViewDialog",
    "MeetingRoomViewDialog",
    "mt_room"
  ],
  [
    "customerservice",
    "customerService",
    "@weapp/customerservice",
    "/mobile/custom/customerservice/726484217844785152/m/base/workorder",
    "/mobile/custom/customerservice/726484217844785152/m/base/workorder/route/{id}",
    "/sp/custom/customerservice/703356776736137216/view/{id}",
    "CustomerserviceCreateDialog",
    "CustomerServiceViewDialog",
    "CustomerServiceViewSideDialog",
    "workOrderBrowser"
  ],
  [
    "workflow/list",
    "workflow_list",
    "@weapp/workflow",
    "/mobile/workflow/index/list",
    "/mobile/workflow/flowpage/view/{id}",
    "/sp/workflow/flowpage/view/{id}",
    "WfCLNewFlowVisibleDialog",
    "WorkflowViewDialog",
    "WorkflowViewSideDialog",
    "wflRequest,wflFinRequest"
  ],
  [
    "ebdfpage",
    "ebuilderworkflow",
    "@weapp/ebdfpage",
    "",
    "/mobile/ebdfpage/ebflowpage/view/{id}",
    "/sp/ebdfpage/ebflowpage/view/{id}",
    "EbWorkflowCreateDialog",
    "EbWorkflowViewDialog",
    "EbWorkflowViewSideDialog",
    ""
  ],
  [
    "formreport",
    "formreport_create",
    "@weapp/formreport",
    "/mobile/formreport",
    "/mobile/formreport/createReport/{id}",
    "",
    "FormreportNewViewDialog",
    "FormReportNewViewMiddleDialog",
    "FormreportNewViewDialog",
    ""
  ],
  [
    "doc",
    "sharefolder",
    "@weapp/doc",
    "/mobile/doc/docList/shareInner_{id}",
    "/mobile/doc/docList/shareInner_{id}",
    "/doc/knowledge/shareInner_{id}",
    "FolderViewDialog",
    "FolderViewDialog",
    "FolderViewSideDialog",
    ""
  ],
  [
    "doc",
    "watchfolder",
    "@weapp/doc",
    "/mobile/doc/docList/watched_{id}",
    "/mobile/doc/docList/watched_{id}",
    "/doc/knowledge/watched_{id}",
    "FolderViewDialog",
    "FolderViewDialog",
    "FolderViewSideDialog",
    ""
  ],
  [
    "formreport",
    "SURVEY_WORKFLOW",
    "@weapp/formreport",
    "",
    "",
    "",
    "",
    "FormSurveyViewDialog",
    "FormSurveyViewDialog",
    ""
  ],
  [
    "archive/core",
    "archive",
    "@weapp/archive",
    "",
    "",
    "/sp/archive/archiveDetail?detailId={id}",
    "ArchiveViewDialog",
    "ArchiveViewDialog",
    "ArchiveViewDialog",
    "archiveBrowser"
  ],
  [
    "signcenter",
    "signcontract",
    "@weapp/signcenter",
    "",
    "/mobile/signcenter/electronic/signList/contractdetail/{id}",
    "",
    "",
    "SignContractViewDialog",
    "SignContractViewDialog",
    ""
  ],
  [
    "batchTask",
    "batchTask",
    "@weapp/uibusiness",
    "",
    "/mobile/uibusiness/batchTask/view/{id}",
    "",
    "",
    "BatchTaskViewDialog",
    "BatchTaskViewSideDialog",
    ""
  ],
  [
    "odoc",
    "odocReceiveUnit",
    "@weapp/odoc",
    "",
    "/mobile/odoc/receiveUtilCard/{id}",
    "/sp/odoc/receiveUtilCard/{id}",
    "",
    "ReceiveUtilCardViewDialog",
    "ReceiveUtilCardViewSideDialog",
    "odocReceiveUnit"
  ],
  [
    "incMsg",
    "incMsg",
    "@weapp/inc",
    "",
    "/mobile/inc/messagelist?batchNo={batchNo}&flag={flag}",
    "",
    "MessageDialog",
    "MessageDialog",
    "MessageDialog",
    ""
  ],
  [
    "doc",
    "folder",
    "@weapp/doc",
    "/mobile/doc/docList/{id}",
    "/mobile/doc/docList/{id}",
    "/sp/doc/folder/{id}",
    "FolderViewDialog",
    "FolderViewDialog",
    "FolderViewSideDialog",
    "folder"
  ],
  [
    "customer/service",
    "workOrder",
    "@weapp/customerservice",
    "/mobile/custom/customerservice/726484217844785152/m/base/workorder",
    "/mobile/custom/customerservice/726484217844785152/m/base/workorder/route/{id}",
    "/sp/custom/customerservice/703356776736137216/view/{id}",
    "CustomerserviceCreateDialog",
    "CustomerServiceViewDialog",
    "CustomerServiceViewSideDialog",
    "workOrderBrowser"
  ],
  [
    "formdatareport",
    "biaoge",
    "@weapp/formreport",
    "/mobile/formreport",
    "/mobile/formreport/datalist/{id}",
    "",
    "",
    "FormreportListViewDialog",
    "FormreportListViewDialog",
    "frpt_form"
  ],
  [
    "marketResource",
    "marketResource",
    "@weapp/market",
    "",
    "/mobile/market/resource/common/resourceInfo/{id}",
    "/sp/market/resourceCommon/{id}",
    "",
    "MarketResourceViewMiddleDialog",
    "",
    ""
  ],
  [
    "fna/workflow",
    "fna/workflow",
    "@weapp/fna",
    "/mobile/fna/apply",
    "/mobile/fna/home/flowpage/sideDialog/view/{id}",
    "/sp/fna/flowpage/centerDialog/view/{id}",
    "",
    "FnaViewDialogAd",
    "FnaViewSideDialogAd",
    "relateApprove,FexsBorrowRequestBrowser,wflRequest"
  ],
  ["esb", "esb", "@weapp/esb", "", "", "", "", "FlowLoggerDialog", "FlowLoggerDialog", ""],
  [
    "task",
    "taskdelayremind",
    "@weapp/task",
    "/mobile/task/delay/list/{id}",
    "",
    "",
    "",
    "TaskDelayListDialog",
    "TaskDelayListDialog",
    ""
  ],
  [
    "crm",
    "customerTree",
    "@weapp/crm",
    "",
    "/mobile/crm/customer/0/customerDetail/{id}",
    "/sp/crm/customer/customerViewPage/{id}",
    "CrmCreateCustomerDialogProvider",
    "CrmCustomerViewMiddleDialog",
    "CrmCustomerViewDialogProvider",
    "customerTree"
  ]
]
